/**
     * @desc 10购买用户盲盒，先调新的一口价合约并将orderHash传入
用于：盲盒详情页，且是系统盲盒isSystem=0
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/buyUserBox', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/buyUserBox', params);
}
